import { TableCell } from '@mui/material';
import styled from 'styled-components';

interface IAreaForm {
  gridTemplateColumns?: string;
}

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  > h2 {
    font-weight: bold;
  }
`;

export const RowInputs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const AreaButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 15px;
  margin-top: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    > button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;

export const TableGrid = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
`;

export const TableCellGrid = styled(TableCell)`
  &&& {
    cursor: default;
    min-width: 100px;
    width: 160px;
    max-width: 160px;
  }
`;

export const TableCellGridLarge = styled(TableCell)`
  &&& {
    cursor: default;
    min-width: 100px;
    width: 215px;
    max-width: 215px;
  }
`;

export const TableCellGridLicensePlate = styled(TableCell)`
  &&& {
    cursor: default;
    min-width: 88px;
    width: 88px;
    max-width: 88px;
  }
`;

export const TableCellGridOrderNr = styled(TableCell)`
  &&& {
    cursor: default;
    min-width: 78px;
    width: 78px;
    max-width: 78px;
  }
`;

export const TableCellGridOrderDate = styled(TableCell)`
  &&& {
    cursor: default;
    min-width: 178px;
    width: 178px;
    max-width: 178px;

    @media (max-width: 1600px) {
      min-width: 215px;
      width: 215px;
      max-width: 215px;
    }
  }
`;

export const QuoteProcurementPartInfoRowTooltip = styled.p`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
`;